import 'Agent/Commissions/components/Schedules/ScheduleDetailsDrawer.sass';
import {Button, Drawer} from '@material-ui/core';
import {clearDetails} from 'Agent/Commissions/ducks/commissionSchedules';
import {ScheduleDetails} from 'Agent/Commissions/models/ScheduleDetails';
import schedulesSelector from 'Agent/Commissions/selectors/schedulesSelector';
import * as NEA from 'fp-ts/lib/NonEmptyArray';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {ReactNode} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import FileDownloadButton, {FileExtension} from 'Shared/components/FileDownloadButton';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {prop} from 'Shared/utilities/prop';

type ScheduleDetailProps = {
  detail: ScheduleDetails['types'][0];
  agencyFilters: AgencyFilters;
};

const ScheduleDetail = ({detail, agencyFilters}: ScheduleDetailProps) => {
  return (
    <div className="schedule-details-drawer__schedule-download">
      <span className="schedule-download__type">{detail.type}</span>
      <FileDownloadButton
        displayTooltip={false}
        downloadedFileName={detail.type!}
        extension={FileExtension.PDF}
        relativeFileLocation={'api/commissions' + detail.link!.href! + addFilterParameters(agencyFilters)}
      >
        Download
      </FileDownloadButton>
    </div>
  );
};

const NoDetailsAvailableMessage: ReactNode = 'No Details Available';

type ScheduleDetailsDrawerProps = {
  selectedAgency: AgencyFilters;
};

const ScheduleDetailsDrawer = ({selectedAgency: agencyFilters}: ScheduleDetailsDrawerProps) => {
  const dispatch = useDispatch();
  const {details} = useSelector(schedulesSelector);

  const scheduleDetailsContent = pipe(
    details,
    O.map(prop('types')),
    O.chain(NEA.fromArray),
    O.map(NEA.map(detail => <ScheduleDetail key={detail.id!} detail={detail} agencyFilters={agencyFilters} />)),
    O.getOrElse(() => NoDetailsAvailableMessage)
  );

  return (
    <Drawer onClose={() => dispatch(clearDetails())} open={O.isSome(details)} anchor="right">
      <div className="schedule-details-drawer">
        <span className="schedule-details-drawer__title">Commission Schedule Downloads:</span>
        {scheduleDetailsContent}
      </div>
      <Button fullWidth onClick={() => dispatch(clearDetails())} color="primary">
        Close
      </Button>
    </Drawer>
  );
};

export default ScheduleDetailsDrawer;
